<div id="standing-authorizations-input-container">
    <mm-standing-authorizations-form [isEditSubmittedProfile$]="editLinkClicked$"></mm-standing-authorizations-form>
</div>
<mm-standing-authorizations-table (editLinkClicked)="editLinkClickedEvent($event)"></mm-standing-authorizations-table>